// removed by extract-text-webpack-plugin
module.exports = {"app":"src-components-App-style__app--RJ1hH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/App/style.scss
// module id = 87
// module chunks = 0